const csr = {
  hero: {
    eyebrow: "CSR Partnership",
    title: "Partner With Us for Social Impact",
    subtitle:
      "Join hands with Jivandhara to bring dignity, care and nourishment to elders and empower women through Gruh Udhyog — every CSR rupee turned into lasting impact.",
    becomePartner: "Become a CSR Partner",
    download: "Download CSR Proposal",
    downloading: "Preparing PDF…",
  },
  about: {
    eyebrow: "Why Jivandhara",
    title: "A trusted partner for meaningful CSR",
    description:
      "For years, Jivandhara has been a second home for elders who need care, companionship and dignity. Our programmes are run transparently, are eligible under Schedule VII of the Companies Act, 2013, and every contribution is reported back to our partners.",
    points: {
      compliance: {
        title: "Schedule VII Compliant",
        desc: "Eligible CSR activities under Section 135 of the Companies Act, 2013.",
      },
      tax: {
        title: "12A & 80G Certified",
        desc: "Registered trust with tax-exempt status for contributions.",
      },
      reporting: {
        title: "Transparent Reporting",
        desc: "Utilisation certificates, photos and impact reports for every project.",
      },
      engagement: {
        title: "Employee Engagement",
        desc: "Volunteering days and campus visits for your teams.",
      },
    },
  },
  areas: {
    eyebrow: "Focus Areas",
    title: "Where your CSR creates impact",
    description:
      "Choose one focus area or combine several — we design the partnership around your CSR goals.",
    elderlyCare: {
      title: "Elderly Care",
      desc: "Safe shelter, attendants, clothing and daily care for elders with no one to look after them.",
    },
    healthcare: {
      title: "Healthcare",
      desc: "Medical check-ups, medicines, physiotherapy and hospital support for residents.",
    },
    meals: {
      title: "Nutritious Meals",
      desc: "Three wholesome meals a day through Bhojanshala and Tiffin Seva for elders in need.",
    },
    community: {
      title: "Community Welfare",
      desc: "Gaushala, festivals, outreach camps and programmes that strengthen the wider community.",
    },
    women: {
      title: "Women Empowerment",
      desc: "Livelihoods for women through Gruh Udhyog — training, production and fair income.",
    },
  },
  impact: {
    title: "Our impact so far",
    elders: "Elders cared for",
    wellWishers: "Well-wishers & donors",
    services: "Services to society",
    years: "Years of seva",
  },
  process: {
    stepLabel: "Step",
    eyebrow: "How It Works",
    title: "Simple steps to partner with us",
    step1: {
      title: "Share your interest",
      desc: "Fill the CSR enquiry form with your focus areas and budget.",
    },
    step2: {
      title: "Discuss & plan",
      desc: "Our team connects with you to design a project that fits your CSR policy.",
    },
    step3: {
      title: "Sign & contribute",
      desc: "We complete the MoU and documentation required for your CSR filing.",
    },
    step4: {
      title: "Track the impact",
      desc: "Receive regular updates, utilisation certificates and impact reports.",
    },
  },
  cta: {
    title: "Ready to create a lasting impact?",
    description:
      "Talk to our CSR team or download the proposal to share with your CSR committee.",
  },
  form: {
    badge: "CSR Partnership Enquiry",
    title: "Let's create impact together",
    subtitle:
      "Share a few details and our CSR team will get in touch within 2 working days.",
    companyName: "Company / Organisation Name",
    contactPerson: "Contact Person Name",
    email: "Official Email",
    mobile: "Mobile Number",
    designation: "Designation",
    interests: "Partnership Interests",
    contribution: "Estimated CSR Contribution",
    duration: "Preferred Partnership Duration",
    message: "Message",
    messagePlaceholder: "Tell us about your CSR goals or any questions…",
    selectPlaceholder: "Select an option",
    consent:
      "I agree that Jivandhara may contact me about this enquiry and use these details as per its privacy policy.",
    submit: "Submit Enquiry",
    submitting: "Submitting…",
    successTitle: "Thank you for reaching out!",
    successMessage:
      "Your CSR partnership enquiry has been received. Our team will contact you shortly.",
    close: "Close",
    validation: {
      companyName: "Please enter your company name",
      contactPerson: "Please enter the contact person's name",
      email: "Please enter a valid official email",
      mobile: "Please enter a valid 10-digit mobile number",
      interests: "Please select at least one partnership interest",
      consent: "Please accept the privacy consent to continue",
    },
    error: "Could not submit your enquiry. Please try again.",
  },
  options: {
    contribution: {
      below50k: "Below ₹50,000",
      "50kTo1L": "₹50,000 – ₹1,00,000",
      "1LTo5L": "₹1,00,000 – ₹5,00,000",
      "5LTo10L": "₹5,00,000 – ₹10,00,000",
      above10L: "Above ₹10,00,000",
      discuss: "To be discussed",
    },
    duration: {
      oneTime: "One-time Contribution",
      "3To6": "3–6 Months",
      "6To12": "6–12 Months",
      longTerm: "Long-term Partnership",
    },
  },
};

export default csr;
